module.exports = __webpack_public_path__ + "media/printed-materials/LINK-TO-FASTWEB-sidebat@2x-e073d597.png";